import { useCallback, useState } from "react";
import { exportReviewsCsv } from "../../../api";

interface ExportArgs {
    trackIds: string[];
    startDate: Date;
    endDate: Date;
}

interface UseExportReviewsCsv {
    exporting: boolean;
    error: string | null;
    run: (args: ExportArgs) => Promise<void>;
}

export const useExportReviewsCsv = (): UseExportReviewsCsv => {
    const [exporting, setExporting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const run = useCallback(async ({ trackIds, startDate, endDate }: ExportArgs) => {
        const token = localStorage.getItem("token");
        if (!token) {
            setError("missing-token");
            return;
        }
        setExporting(true);
        setError(null);
        try {
            await exportReviewsCsv({ token, trackIds, startDate, endDate });
        } catch (e: any) {
            setError(e?.message || "unknown-error");
        } finally {
            setExporting(false);
        }
    }, []);

    return { exporting, error, run };
};
